import { useMemo, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'

type SearchParamProps = Record<string, string | number | undefined>

const shallowEqual = (first: SearchParamProps, second: SearchParamProps) => {
  const firstKeys = Object.keys(first)
  const secondKeys = Object.keys(second)

  return (
    firstKeys.length === secondKeys.length &&
    firstKeys.every((key) => first[key] === second[key])
  )
}

export const useInstantRouting = (filterKeys: string[]) => {
  const [searchParams] = useSearchParams()
  const lastFiltersRef = useRef<SearchParamProps>()

  return useMemo(() => {
    const newQueryParams: SearchParamProps = {}
    filterKeys.forEach((key) => {
      const value = searchParams.get(key)
      if (value !== null) {
        newQueryParams[key] =
          Number.isInteger(Number(value)) &&
          (value.charAt(0) !== '0' || value.length === 1)
            ? Number(value)
            : value
      }
    })

    if (lastFiltersRef.current && shallowEqual(lastFiltersRef.current, newQueryParams)) {
      return lastFiltersRef.current
    }

    lastFiltersRef.current = newQueryParams
    return newQueryParams
  }, [searchParams, filterKeys])
}
